import { render, staticRenderFns } from "./EomItemsTable.vue?vue&type=template&id=1b65b8a2&scoped=true&"
import script from "./EomItemsTable.vue?vue&type=script&lang=js&"
export * from "./EomItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./EomItemsTable.vue?vue&type=style&index=0&id=1b65b8a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65b8a2",
  null
  
)

export default component.exports